export enum UploadStorageProviderType {
  S3 = 's3',
  SHAREPOINT = 'sharepoint',
}
